const AtualizaInputs = require('./AtualizaInputs');
const template = require('lodash/template');
const GrupoAprovadorInput = require('./GrupoAprovadorInput');
const to_array = require('to_array');
const Lang = require('lang');

function EtapaAprovacaoInput(container, json, usuarios) {
  const $container = $(container);
  const $btnNovaEtapa = $('#novaEtapa');
  const $btnConcluir = $('#concluir');
  const $btnVoltarEtapa = $('#voltarEtapa');
  const $btnAvancarEtapa = $('#avancarEtapa');
  const $formFluxo = $('#formFluxo');
  const template_string = $('#etapa-aprovacao').html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  const _template = template(template_string);

  if(!$container.length) {
    return;
  }

  let count = 0;
  let idEtapa = 1;

  $btnNovaEtapa.on('click', function btnNovaEtapaClick(event, jsonEtapa) {
    const descricaoFluxo = $('#descricao').val();

    $btnVoltarEtapa.removeClass('hidden');
    $btnAvancarEtapa.addClass('hidden');
    $('.etapa[data-etapa-id]:not(.hidden)').addClass('hidden');

    count++;
    idEtapa++;

    $container.append(_template({
      etapa: idEtapa,
      fluxo: descricaoFluxo
    }));

    if(jsonEtapa) {
      $('[name="condicaoFilho[' + idEtapa + ']"]').val(jsonEtapa.condicaoFilho);
    }

    GrupoAprovadorInput('#grupos-aprovadores-' + idEtapa, jsonEtapa ? jsonEtapa.filhas : null, usuarios);
    AtualizaInputs.init();

    if(!jsonEtapa) {
      $('#grupos-aprovadores-' + idEtapa + ' + .add-grupo').trigger('click');
    } else {
      const $etapaObrigatoria = $('[name="etapaObrigatoria[' + idEtapa + ']"]');
      const $valorCondicao = $('[name="valorCondicao[' + idEtapa + ']"]');

      if($etapaObrigatoria.length) {
        $etapaObrigatoria.val(jsonEtapa.valorEntradaEtapa > 0 ? 0 : 1).trigger('change');
        $valorCondicao.val(jsonEtapa.valorEntradaEtapa);
      }
    }
  });

  $container.on('click', '.remove', function removeClick(e) {
    if(count < 1) {
      return false;
    }

    count--;

    const $etapa = $(this).closest('.etapa');

    $btnVoltarEtapa.trigger('click');

    if(count === 0) {
      $btnAvancarEtapa.addClass('hidden');
      $btnVoltarEtapa.addClass('hidden');
    }

    $etapa.remove();
  });

  $btnVoltarEtapa.on('click', function btnVoltarEtapaClick() {
    const $etapaAtiva = $('.etapa[data-etapa-id]:not(.hidden)');
    const idEtapaAtiva = parseInt($etapaAtiva.data('etapaId'));
    let idEtapaProx = idEtapaAtiva - 1;
    $btnAvancarEtapa.removeClass('hidden');

    while(true) {

      if(idEtapaProx < 1 || isNaN(idEtapaProx)) {
        break;
      }

      const $proxEtapa = $(`.etapa[data-etapa-id=${idEtapaProx}]`);

      // console.log('Próximo:', idEtapaProx);
      // console.log('Existe?:', !!$proxEtapa.length);
      // console.log('Elemento:', $proxEtapa[0]);

      if(!$proxEtapa.length) {
        idEtapaProx--;
        continue;
      }


      $etapaAtiva.addClass('hidden');
      $proxEtapa.removeClass('hidden');

      if(idEtapaProx === 1) {
        this.classList.add('hidden')
      }

      break;
    }
  });

  $btnAvancarEtapa.on('click', function btnAvancarEtapaClick() {
    const $etapaAtiva = $('.etapa[data-etapa-id]:not(.hidden)');
    const idEtapaAtiva = parseInt($etapaAtiva.data('etapaId'));
    let idEtapaProx = idEtapaAtiva + 1;
    $btnVoltarEtapa.removeClass('hidden');

    while(true) {

      if(idEtapaProx > idEtapa || isNaN(idEtapaProx)) {
        break;
      }

      const $proxEtapa = $(`.etapa[data-etapa-id=${idEtapaProx}]`);

      // console.log('Próximo:', idEtapaProx);
      // console.log('Existe?:', !!$proxEtapa.length);
      // console.log('Elemento:', $proxEtapa[0]);

      if(!$proxEtapa.length) {
        idEtapaProx++;
        continue;
      }


      $etapaAtiva.addClass('hidden');
      $proxEtapa.removeClass('hidden');

      if(idEtapaProx === idEtapa) {
        this.classList.add('hidden')
      }

      break;
    }

  });

  $btnConcluir.on('click', function btnConcluirClick() {
    const etapas = to_array(document.getElementsByClassName('etapa'));
    const hasNoValue = input => !input.value;

    const hasEmptyStep = etapas.reduce((hasEmptyStep, etapa) => {
      const inputs = to_array(etapa.querySelectorAll('[name^="usuarios["'));
      return hasEmptyStep || inputs.every(hasNoValue);
    }, false);

    if(hasEmptyStep) {
      bootbox.alert({
        size: 'small',
        title: Lang.get('js/src/fluxos-aprovacao/EtapaAprovacaoInput.no_approver'),
        message: Lang.get('js/src/fluxos-aprovacao/EtapaAprovacaoInput.not_possible_to_create_steps'),
        closeButton: false
      });

      return false;
    }

    $formFluxo.trigger('submit');
  });

  if (json) {
    json.forEach(function(item, n) {
      //A primeira etapa já vem carregada na view, então só chamaremos os grupos
      //dentro dela, ao inves de criar uma nova etapa
      if(n === 0) {
        $('[name="condicaoFilho[1]"]').val(item.condicaoFilho);
        GrupoAprovadorInput('#grupos-aprovadores-1', item.filhas, usuarios);
      } else {
        $btnNovaEtapa.trigger('click', [item]);
      }
    });

    // Após criar as etapas do fluxo, voltar para a primeira etapa
    const $etapaAtiva = $('.etapa[data-etapa-id]:not(.hidden)');
    const idEtapaAtiva = parseInt($etapaAtiva.data('etapaId'));

    if(idEtapaAtiva > 1) {
      $etapaAtiva.addClass('hidden');
      $btnAvancarEtapa.removeClass('hidden');
      $('.etapa[data-etapa-id=1]').removeClass('hidden');

      $btnVoltarEtapa.addClass('hidden');
    }
  }
}

module.exports = EtapaAprovacaoInput;
